
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-image-translator",
      function () {
        return require("private-next-pages/ai-image-translator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-image-translator"])
      });
    }
  